import { type Static, Type } from '@sinclair/typebox';
import { ProductSchema } from './product.js';

// =====================================================================================================================
// Search Autocomplete
// =====================================================================================================================

export const SearchAutocompleteBodySchema = Type.Object({
  search: Type.String(),
});
export type SearchAutocompleteBody = Static<typeof SearchAutocompleteBodySchema>;

export const SearchAutocompleteResponseSchema = Type.Object({
  products: Type.Object({
    results: Type.Array(
      Type.Pick(ProductSchema, [
        '_key',
        'item_description_local_language',
        'supplier_item_code',
        'attributes',
        'taxons',
      ]),
    ),
    numberOfResults: Type.Number(),
  }),
  taxons: Type.Array(
    Type.Object({
      _key: Type.String(),
      names: Type.Array(Type.String()),
    }),
  ),
});
export type SearchAutocompleteResponse = Static<typeof SearchAutocompleteResponseSchema>;
